import React from 'react';

const DashboardContext = React.createContext({
  dates: '',
  rangesArray: [],
});

export default DashboardContext;
